import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { PinchZoomModule } from 'ngx-pinch-zoom';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ToastComponent } from './shared/toast/toast.component';
import { HttpClientModule } from '@angular/common/http';
import { LottieModule } from 'ngx-lottie';
import player from 'lottie-web';
import { FCM } from 'cordova-plugin-fcm-with-dependecy-updated/ionic/ngx';
// import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { LottieSplashScreen } from '@ionic-native/lottie-splash-screen/ngx';
import { ShowImageComponent } from './pages/show-image/show-image.component';
import { SocketIoConfig, SocketIoModule } from 'ngx-socket-io';
import { AppSettings } from 'src/app/core/constant';
import { BackgroundMode } from '@ionic-native/background-mode/ngx';

const config: SocketIoConfig = { url: AppSettings.API_ENDPOINT, options: {} };

// import { FCM } from '@ionic-native/fcm/ngx';
export function playerFactory() {
  return player;
}




@NgModule({
  declarations: [AppComponent,ToastComponent , ShowImageComponent],
  entryComponents: [],
  imports: [PinchZoomModule, BrowserModule, IonicModule.forRoot(), AppRoutingModule ,
    LottieModule.forRoot({ player: playerFactory }),
    SocketIoModule.forRoot(config),
    HttpClientModule ,
   ],
  providers: [{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    ToastComponent ,FCM,
    // SplashScreen , 
    StatusBar,
    LottieSplashScreen,
    BackgroundMode

   ],
  bootstrap: [AppComponent],
})
export class AppModule {}
